import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const MorningNotesServiceContext = createContext(undefined)

const MorningNotesServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={MorningNotesServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/content/morning_notes`, payload)
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/content/morning_notes/${id}`)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/content/morning_notes${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/content/morning_notes/${id}`, payload)
          return data
        },
        delete: async (id) => {
          const {data} = await axios.delete(`/api/v1/content/morning_notes/${id}`)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

MorningNotesServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useMorningNotesService = () => {
  const context = useContext(MorningNotesServiceContext)
  if (context === undefined) {
    throw new Error('MorningNotesServiceContext was not provided. Make sure your component is a child of the MorningNotesServiceProvider.')
  }
  return context
}

const useMorningNotesQuery = ({query, ...otherProps}) => {
  const morningNotesService = useMorningNotesService()
  return useSimpleQuery({
    queryKey: `morning_notes-list-${JSON.stringify(query)}`,
    queryFn: async () => morningNotesService.list(query),
    ...otherProps
  })
}

const useMorningNoteQuery = ({id, enabled, ...otherProps}) => {
  const morningNotesService = useMorningNotesService()
  return useSimpleQuery({
    queryKey: `morning_notes-get-${id}`,
    queryFn: async () => morningNotesService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {MorningNotesServiceProvider, useMorningNotesService, useMorningNotesQuery, useMorningNoteQuery}
